import { Suspense } from "react";
import { LoadingScreen } from "@/components/ui/loading-screen";
import { EcosuiteErrorBoundary } from "@/components/error-boundary";
import RootUserLayout from "../layout";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@/components/ui/card";
import { useLeadsAnalyticsData } from "./hooks/useLeadsAnalyticsData";
import { TOP_NAV } from "./constants";

import { LeadsWeightedRevenueByStageChart } from "./components/leads-charts/leads-weighted-revenue-by-stage-chart";
import { LeadsWeightedRevenueByMonthChart } from "./components/leads-charts/leads-weighted-revenue-by-month-chart";
import { LeadsRecurringOneTimeBreakdownChart } from "./components/leads-charts/leads-recurring-one-time-breakdown-chart";

export default function LeadsAnalytics() {
  return (
    <RootUserLayout pageTitle="Leads Analytics" topNav={TOP_NAV}>
      <Suspense
        fallback={
          <LoadingScreen
            text="Loading Leads Analytics..."
            className="h-[calc(100vh-180px)]"
          />
        }
      >
        <EcosuiteErrorBoundary>
          <LeadsAnalyticsContent />
        </EcosuiteErrorBoundary>
      </Suspense>
    </RootUserLayout>
  );
}

function LeadsAnalyticsContent() {
  const {
    weightedRevenueByStage,
    weightedRevenueByMonth,
    recurringOneTimeBreakdown,
  } = useLeadsAnalyticsData();

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {/* Weighted Revenue By Stage */}
        <Card>
          <CardHeader>
            <CardTitle>Weighted Revenue by Stage</CardTitle>
            <CardDescription>
              Probability-adjusted sum of (annual + onboarding) revenue for each
              stage
            </CardDescription>
          </CardHeader>
          <CardContent>
            <LeadsWeightedRevenueByStageChart data={weightedRevenueByStage} />
          </CardContent>
        </Card>

        {/* Weighted Revenue By Month */}
        <Card>
          <CardHeader>
            <CardTitle>Weighted Revenue by Month</CardTitle>
            <CardDescription>
              Probability-adjusted revenue forecast grouped by close month
            </CardDescription>
          </CardHeader>
          <CardContent>
            <LeadsWeightedRevenueByMonthChart data={weightedRevenueByMonth} />
          </CardContent>
        </Card>

        {/* Recurring vs One-time breakdown */}
        <Card>
          <CardHeader>
            <CardTitle>Recurring vs One-Time Revenue</CardTitle>
            <CardDescription>
              Proportion of annual subscription vs onboarding totals
            </CardDescription>
          </CardHeader>
          <CardContent>
            <LeadsRecurringOneTimeBreakdownChart
              data={recurringOneTimeBreakdown}
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
